import React, { useState, useRef } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

export default function Bookdownload() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const formValidationSchema = Yup.object().shape({
    name: Yup.string()
      .min(3, 'Minimum 3 characters')
      .matches(/^[a-zA-Z]+(?: [a-zA-Z]+)*$/, 'Should be in A-Z, a-z letters')
      .required('Please enter your name'),
    email: Yup.string()
      .email('Please enter a valid email address')
      .required('Please your email address'),
    phone: Yup.string()
      .required('Please enter phone number')
      .matches(/^\d+$/, 'Please enter a valid phone number')
      .min(10, 'Phone number must be at least 10 digits')
      .max(15, 'Phone number must not exceed 15 digits'),
    company: Yup.string()
      .min(3, 'Company name must be at least 3 characters')
      .required('Please enter your Company name'),
  });

  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
      phone: '',
      company: '',      
    },
    validationSchema: formValidationSchema,
    onSubmit: async (values) => {
      setIsSubmitting(true);
      try {
        const response = await axios.post('https://capdigi.tech/2024/capdigisoft/v1/capbackend/submitForm.php', values);

        if (response.status === 200) {
          // Reset the form
          formik.resetForm();
          const fileUrl = response.data.fileUrl;
          window.open(fileUrl, '_blank');
          setIsSubmitting(false);

          navigate("/thankyou"); // Redirect to thank you page
        } else {
          setIsSubmitting(false);
          console.error("Error submitting form data");
        }
      } catch (error) {
        setIsSubmitting(false);
        console.error("Error:", error);
      }
    },
  });

  return (
    <section className="section" id="contact">
      <div className="ct-wrapper shadow-md rounded-lg overflow-hidden">
        <div className="card-body">
          <div className="p-4">
            <form onSubmit={formik.handleSubmit}>
              {/* Name field */}
              <div className="mb-4">
                <label htmlFor="name" className="form-label">Full Name <span className="text-danger">*</span></label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  placeholder='Full Name'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                />
                {formik.touched.name && formik.errors.name ? (
                  <div className="text-danger">{formik.errors.name}</div>
                ) : null}
              </div>

              {/* Email field */}
              <div className="mb-4">
                <label htmlFor="email" className="form-label">Email <span className="text-danger">*</span></label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  placeholder='Email'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                />
                {formik.touched.email && formik.errors.email ? (
                  <div className="text-danger">{formik.errors.email}</div>
                ) : null}
              </div>

              {/* Phone field */}
              <div className="mb-4">
                <label htmlFor="phone" className="form-label">Phone Number <span className="text-danger">*</span></label>
                <PhoneInput
                  country={'us'}
                  value={formik.values.phone}
                  placeholder='Phone'
                  onChange={(phone) => formik.setFieldValue('phone', phone)}
                  containerStyle={{ marginTop: "0.5rem" }}
                    inputStyle={{
                      width: "100%",
                      height: "38px",
                    }}
                />
                {formik.touched.phone && formik.errors.phone ? (
                  <div className="text-danger">{formik.errors.phone}</div>
                ) : null}
              </div>

              {/* Company field */}
              <div className="mb-4">
                <label htmlFor="company" className="form-label">Company Name <span className="text-danger">*</span></label>
                <input
                  type="text"
                  className="form-control"
                  id="company"
                  name="company"
                  placeholder='Company Name'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.company}
                />
                {formik.touched.company && formik.errors.company ? (
                  <div className="text-danger">{formik.errors.company}</div>
                ) : null}
              </div>

             
              <button type="submit" className="btn cust-btn-primary" disabled={isSubmitting}>
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
